import { render, staticRenderFns } from "./CertificateBlank.vue?vue&type=template&id=ecc37170&scoped=true&"
import script from "./CertificateBlank.vue?vue&type=script&lang=js&"
export * from "./CertificateBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc37170",
  null
  
)

export default component.exports